import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const DEFAULT_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
let cachedTimezone: string | null = null;

export function useTimezone() {
  const [timezone, setTimezone] = useState(cachedTimezone || DEFAULT_TIMEZONE);

  useEffect(() => {
    if (cachedTimezone) return;
    supabase
      .from("platform_settings")
      .select("value")
      .eq("key", "platform_timezone")
      .single()
      .then(({ data }) => {
        const val = data?.value || DEFAULT_TIMEZONE;
        cachedTimezone = val;
        setTimezone(val);
      });
  }, []);

  return timezone;
}
